var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "teas-buffer-page" }, [
    _c("div", { staticClass: "image-wrap" }, [
      _c("img", {
        attrs: { src: require("_teas/public/img/product/save.png"), alt: "" },
      }),
    ]),
    _c("p", [_vm._v(_vm._s(_vm.file.text || "暂无名称"))]),
    _c("div", { staticClass: "function-group-div" }, [
      !_vm.hiddenPreview && _vm.isShowPreview
        ? _c(
            "div",
            { staticClass: "prrviewBtn", on: { click: _vm.previewFile } },
            [_vm._v(" 预览 ")]
          )
        : _vm._e(),
      !_vm.hiddenDownLoad && _vm.isShowDownLoad
        ? _c(
            "div",
            { staticClass: "downloadBtn", on: { click: _vm.downloadFile } },
            [_vm._v(" 下载 ")]
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }